"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldFormatter = void 0;

var lodash_isboolean_1 = __importDefault(require("lodash.isboolean"));

var lodash_isnil_1 = __importDefault(require("lodash.isnil"));

var lodash_escaperegexp_1 = __importDefault(require("lodash.escaperegexp"));

var FieldFormatter = /*#__PURE__*/function () {
  function FieldFormatter(formatterOptions) {
    _classCallCheck(this, FieldFormatter);

    this._headers = null;
    this.formatterOptions = formatterOptions;

    if (formatterOptions.headers !== null) {
      this.headers = formatterOptions.headers;
    }

    this.REPLACE_REGEXP = new RegExp(formatterOptions.quote, 'g');
    var escapePattern = "[".concat(formatterOptions.delimiter).concat(lodash_escaperegexp_1.default(formatterOptions.rowDelimiter), "|\r|\n]");
    this.ESCAPE_REGEXP = new RegExp(escapePattern);
  }

  _createClass(FieldFormatter, [{
    key: "headers",
    set: function set(headers) {
      this._headers = headers;
    }
  }, {
    key: "shouldQuote",
    value: function shouldQuote(fieldIndex, isHeader) {
      var quoteConfig = isHeader ? this.formatterOptions.quoteHeaders : this.formatterOptions.quoteColumns;

      if (lodash_isboolean_1.default(quoteConfig)) {
        return quoteConfig;
      }

      if (Array.isArray(quoteConfig)) {
        return quoteConfig[fieldIndex];
      }

      if (this._headers !== null) {
        return quoteConfig[this._headers[fieldIndex]];
      }

      return false;
    }
  }, {
    key: "format",
    value: function format(field, fieldIndex, isHeader) {
      var preparedField = "".concat(lodash_isnil_1.default(field) ? '' : field).replace(/\0/g, '');
      var formatterOptions = this.formatterOptions;

      if (formatterOptions.quote !== '') {
        var shouldEscape = preparedField.indexOf(formatterOptions.quote) !== -1;

        if (shouldEscape) {
          return this.quoteField(preparedField.replace(this.REPLACE_REGEXP, formatterOptions.escapedQuote));
        }
      }

      var hasEscapeCharacters = preparedField.search(this.ESCAPE_REGEXP) !== -1;

      if (hasEscapeCharacters || this.shouldQuote(fieldIndex, isHeader)) {
        return this.quoteField(preparedField);
      }

      return preparedField;
    }
  }, {
    key: "quoteField",
    value: function quoteField(field) {
      var quote = this.formatterOptions.quote;
      return "".concat(quote).concat(field).concat(quote);
    }
  }]);

  return FieldFormatter;
}();

exports.FieldFormatter = FieldFormatter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mb3JtYXR0ZXIvRmllbGRGb3JtYXR0ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLElBQUEsa0JBQUEsR0FBQSxlQUFBLENBQUEsT0FBQSxDQUFBLGtCQUFBLENBQUEsQ0FBQTs7QUFDQSxJQUFBLGNBQUEsR0FBQSxlQUFBLENBQUEsT0FBQSxDQUFBLGNBQUEsQ0FBQSxDQUFBOztBQUNBLElBQUEscUJBQUEsR0FBQSxlQUFBLENBQUEsT0FBQSxDQUFBLHFCQUFBLENBQUEsQ0FBQTs7SUFJYSxjO0FBU1QsMEJBQW1CLGdCQUFuQixFQUEyRDtBQUFBOztBQU5uRCxTQUFBLFFBQUEsR0FBNEIsSUFBNUI7QUFPSixTQUFLLGdCQUFMLEdBQXdCLGdCQUF4Qjs7QUFDQSxRQUFJLGdCQUFnQixDQUFDLE9BQWpCLEtBQTZCLElBQWpDLEVBQXVDO0FBQ25DLFdBQUssT0FBTCxHQUFlLGdCQUFnQixDQUFDLE9BQWhDO0FBQ0g7O0FBQ0QsU0FBSyxjQUFMLEdBQXNCLElBQUksTUFBSixDQUFXLGdCQUFnQixDQUFDLEtBQTVCLEVBQW1DLEdBQW5DLENBQXRCO0FBQ0EsUUFBTSxhQUFhLGNBQU8sZ0JBQWdCLENBQUMsU0FBeEIsU0FBb0MscUJBQUEsQ0FBQSxPQUFBLENBQWEsZ0JBQWdCLENBQUMsWUFBOUIsQ0FBcEMsWUFBbkI7QUFDQSxTQUFLLGFBQUwsR0FBcUIsSUFBSSxNQUFKLENBQVcsYUFBWCxDQUFyQjtBQUNIOzs7O1NBRUQsYUFBbUIsT0FBbkIsRUFBb0M7QUFDaEMsV0FBSyxRQUFMLEdBQWdCLE9BQWhCO0FBQ0g7OztXQUVPLHFCQUFZLFVBQVosRUFBZ0MsUUFBaEMsRUFBaUQ7QUFDckQsVUFBTSxXQUFXLEdBQUcsUUFBUSxHQUFHLEtBQUssZ0JBQUwsQ0FBc0IsWUFBekIsR0FBd0MsS0FBSyxnQkFBTCxDQUFzQixZQUExRjs7QUFDQSxVQUFJLGtCQUFBLENBQUEsT0FBQSxDQUFVLFdBQVYsQ0FBSixFQUE0QjtBQUN4QixlQUFPLFdBQVA7QUFDSDs7QUFDRCxVQUFJLEtBQUssQ0FBQyxPQUFOLENBQWMsV0FBZCxDQUFKLEVBQWdDO0FBQzVCLGVBQU8sV0FBVyxDQUFDLFVBQUQsQ0FBbEI7QUFDSDs7QUFDRCxVQUFJLEtBQUssUUFBTCxLQUFrQixJQUF0QixFQUE0QjtBQUN4QixlQUFPLFdBQVcsQ0FBQyxLQUFLLFFBQUwsQ0FBYyxVQUFkLENBQUQsQ0FBbEI7QUFDSDs7QUFDRCxhQUFPLEtBQVA7QUFDSDs7O1dBRU0sZ0JBQU8sS0FBUCxFQUFzQixVQUF0QixFQUEwQyxRQUExQyxFQUEyRDtBQUM5RCxVQUFNLGFBQWEsR0FBRyxVQUFHLGNBQUEsQ0FBQSxPQUFBLENBQU0sS0FBTixJQUFlLEVBQWYsR0FBb0IsS0FBdkIsRUFBK0IsT0FBL0IsQ0FBdUMsS0FBdkMsRUFBOEMsRUFBOUMsQ0FBdEI7QUFEOEQsVUFFdEQsZ0JBRnNELEdBRWpDLElBRmlDLENBRXRELGdCQUZzRDs7QUFHOUQsVUFBSSxnQkFBZ0IsQ0FBQyxLQUFqQixLQUEyQixFQUEvQixFQUFtQztBQUMvQixZQUFNLFlBQVksR0FBRyxhQUFhLENBQUMsT0FBZCxDQUFzQixnQkFBZ0IsQ0FBQyxLQUF2QyxNQUFrRCxDQUFDLENBQXhFOztBQUNBLFlBQUksWUFBSixFQUFrQjtBQUNkLGlCQUFPLEtBQUssVUFBTCxDQUFnQixhQUFhLENBQUMsT0FBZCxDQUFzQixLQUFLLGNBQTNCLEVBQTJDLGdCQUFnQixDQUFDLFlBQTVELENBQWhCLENBQVA7QUFDSDtBQUNKOztBQUNELFVBQU0sbUJBQW1CLEdBQUcsYUFBYSxDQUFDLE1BQWQsQ0FBcUIsS0FBSyxhQUExQixNQUE2QyxDQUFDLENBQTFFOztBQUNBLFVBQUksbUJBQW1CLElBQUksS0FBSyxXQUFMLENBQWlCLFVBQWpCLEVBQTZCLFFBQTdCLENBQTNCLEVBQW1FO0FBQy9ELGVBQU8sS0FBSyxVQUFMLENBQWdCLGFBQWhCLENBQVA7QUFDSDs7QUFDRCxhQUFPLGFBQVA7QUFDSDs7O1dBRU8sb0JBQVcsS0FBWCxFQUF3QjtBQUFBLFVBQ3BCLEtBRG9CLEdBQ1YsS0FBSyxnQkFESyxDQUNwQixLQURvQjtBQUU1Qix1QkFBVSxLQUFWLFNBQWtCLEtBQWxCLFNBQTBCLEtBQTFCO0FBQ0g7Ozs7OztBQXhETCxPQUFBLENBQUEsY0FBQSxHQUFBLGNBQUEiLCJzb3VyY2VSb290IjoiIn0=